<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card>
    <h4 class>{{$t('DefaultSlot')}}</h4>

    <form>
      <div class="tab-text">
        <div v-for="(slot,index1) in allTimeslot" :key="index1" class="mt-5">
          <div class="vx-row">
            <div class="vx-col mt-5">
              <span>{{$t('Slot')}}</span>
              {{index1 + 1 }}
            </div>
            <div class="vx-col mt-5">
              <flat-pickr
                :config="configdateTimePicker"
                v-model="slot.start_time"
                :placeholder="$t('StartTime')"
                class="flatpickr-input"
                v-validate="'required'"
                :name="'start_time'+index1"
                @input="validateStartDate(index1)"
                :data-vv-as="$t('StatTime')"
              />
              <br />

              <span class="text-danger">{{ errors.first('start_time'+index1) }}</span>
              <span :class="'text-danger startdate-error--'+index1"></span>
            </div>
            <div class="vx-col mt-5">
              <flat-pickr
                :config="configdateTimePicker"
                v-model="slot.end_time"
                :placeholder="$t('EndTime')"
                class="flatpickr-input"
                v-validate="'required'"
                :name="'end_time'+index1"
                @input="validateEndDate(index1)"
                :data-vv-as="$t('EndTime')"
              />
              <br />
              <span class="text-danger">{{ errors.first('end_time'+index1) }}</span>
              <span :class="'text-danger enddate-error--'+index1"></span>
            </div>
            <div class="vx-col mt-5">
              <feather-icon
                v-if="index1 != 0"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="deleteTitmSlot(index1,slot.id)"
              />
            </div>
            <div class="vx-col mt-5">
              <vs-button
                v-if="index1 == 0"
                color="primary"
                type="filled"
                @click="addMore"
              >{{$t('AddMore')}}</vs-button>
            </div>
          </div>
        </div>
        <div class="save-btn">
          <vs-button
            color="primary"
            type="filled"
            class="ml-12"
            @click="saveTimeSlot(index1)"
          >{{$t('Save')}}</vs-button>
        </div>
      </div>
    </form>
  </vx-card>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import $ from "jquery";
import moment from "moment";
// For custom error message
import { Validator } from "vee-validate";

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true
      },

      allTimeslot: [
        {
          start_time: null,
          end_time: null
        }
      ],
      start_time_error: false,
      end_time_error: false
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function(value) {
        this.loadLocale(value);
        Object.keys(this.allTimeslot).forEach(i => {
          this.validateStartDate(i, i + 1);
          this.validateEndDate(i, i + 1);
        });
      }
    }
  },
  mounted() {
    this.user_id = this.$store.getters.currentUser.id;
    this.loadLocale(this.$i18n.locale);
    // get the time slots
    this.getTimeSlots(this.user_id);
  },
  methods: {
    //Get the time slot based on user login
    getTimeSlots(id) {
      this.$store.dispatch("GetSettingTimeSlots", id).then(response => {
        let data = response.data.data;

        if (data.slots.length == 0) {
          this.allTimeslot = [
            {
              start_time: null,
              end_time: null
            }
          ];
        } else {
          this.allTimeslot = data.slots;
        }
      });
    },

    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then(locale => {
        Validator.localize(code, locale);
      });
    },

    // function for add new row
    addMore() {
      this.allTimeslot.push({
        start_time: null,
        end_time: null
      });
    },
    /*Delete existing time slot
    pos is used for value of current day
    index is used for position for current row*/
    deleteTitmSlot(pos) {
      this.allTimeslot.splice(pos, 1);
    },
    /*function for save time slot
      Here index is the day value
    */
    saveTimeSlot(index) {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (
            result &&
            this.start_time_error != true &&
            this.end_time_error != true
          ) {
            let inputData = {
              company_id: this.user_id,

              slots: this.allTimeslot
            };
            //Call API for save time slot
            this.$store
              .dispatch("AddSettingSlots", inputData)
              .then(response => {
                this.$vs.notify({
                  title: this.$t("TimeSlotAdded"),
                  text: "",
                  color: "success",
                  position: "top-center"
                });
              });
          }
        });
      });
    },

    //Get the time slot based on user login

    validateStartDate(pos, nextIndex = "") {
      var start_time = moment(this.allTimeslot[pos].start_time, "HH:mm:ss");
      var end_time = moment(this.allTimeslot[pos].end_time, "HH:mm:ss");
      $(".startdate-error--" + pos).html("");
      this.start_time_error = false;

      Object.keys(this.allTimeslot).forEach(i => {
        if (pos != i) {
          if (nextIndex == "" || i <= nextIndex) {
            let current_start_time = moment(
              this.allTimeslot[i].start_time,
              "HH:mm:ss"
            );
            let current_end_time = moment(
              this.allTimeslot[i].end_time,
              "HH:mm:ss"
            );

            if (
              start_time.isBetween(current_start_time, current_end_time) == true
            ) {
              // check in between selected range
              $(".startdate-error--" + pos).html(this.$t("StartDateError"));
              this.start_time_error = true;
            } else if (
              start_time >= current_start_time &&
              start_time < current_end_time
            ) {
              // checked if same as selcetd date range
              $(".startdate-error--" + pos).html(
                this.$t("StartDateRangeError")
              );
              this.start_time_error = true;
            } else if (start_time >= end_time) {
              // check if greater than end date
              $(".startdate-error--" + pos).html(this.$t("StartTimeLessErr"));
              this.start_time_error = true;
            } else if (
              current_start_time.isBetween(start_time, end_time) == true
            ) {
              // check in between selected range
              $(".startdate-error--" + pos).html(this.$t("StartDateError"));
            }
          }
        } else if (start_time >= end_time) {
          // check if greater than end date
          $(".startdate-error--" + pos).html(this.$t("StartTimeLessErr"));
        }
      });
    },

    /**
     * End time validtaion
     */
    validateEndDate(pos, nextIndex = "") {
      var start_time = moment(this.allTimeslot[pos].start_time, "HH:mm:ss");
      var end_time = moment(this.allTimeslot[pos].end_time, "HH:mm:ss");
      $(".enddate-error--" + pos).html("");
      this.end_time_error = false;

      Object.keys(this.allTimeslot).forEach(i => {
        if (pos != i) {
          if (nextIndex == "" || i <= nextIndex) {
            let current_start_time = moment(
              this.allTimeslot[i].start_time,
              "HH:mm:ss"
            );
            let current_end_time = moment(
              this.allTimeslot[i].end_time,
              "HH:mm:ss"
            );

            if (
              end_time.isBetween(current_start_time, current_end_time) == true
            ) {
              // check in between selected range
              $(".enddate-error--" + pos).html(this.$t("EndtDateError"));
              this.end_time_error = true;
            } else if (
              end_time > current_start_time &&
              end_time < current_end_time
            ) {
              // checked if same as selcetd date range
              $(".enddate-error--" + pos).html(this.$t("EndDateRangeError"));
              this.end_time_error = true;
            } else if (end_time <= start_time) {
              // check if greater than end date
              $(".enddate-error--" + pos).html(this.$t("EndTimeLessError"));
              this.end_time_error = true;
            } else if (
              current_start_time.isBetween(start_time, end_time) == true
            ) {
              // check in between selected range
              $(".startdate-error--" + pos).html(this.$t("EndDateRangeError"));
            }
          }
        } else if (start_time >= end_time) {
          // check if greater than end date
          $(".enddate-error--" + pos).html(this.$t("EndTimeLessError"));
        }
      });

      if (nextIndex == "") {
        this.validateStartDate(pos);
      }
    }
  }
};
</script>

<style lang="stylus" scope>
.flatpickr-input {
  width: 253px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.err {
  border: 2px solid red;
}

.save-btn {
  margin: 25px 0px 0px 43px;
}

.err_cls {
  color: red !important;
}

.custom-err {
  margin: 20px 120px;
}
</style>    